import { ORIENTATION } from './constants';
import { getOriginalPage } from './page';

export function hasSameOrientation(page, photo) {
  return (
    (page.orientation === ORIENTATION.PORTRAIT && photo.height >= photo.width) ||
    (page.orientation === ORIENTATION.LANDSCAPE && photo.height <= photo.width)
  );
}

export function getOtherOrientation(page) {
  return page.orientation === ORIENTATION.PORTRAIT ? ORIENTATION.LANDSCAPE : ORIENTATION.PORTRAIT;
}

export function isChangeOrientationEnabled(template, page) {
  const originalPage = getOriginalPage(template, page);

  if (originalPage.orientation) {
    const otherOrientation = getOtherOrientation(originalPage);
    const otherOrientationPageId = originalPage[otherOrientation];

    if (template.pages.find((p) => p.id === otherOrientationPageId)) {
      return true;
    }
  }

  return false;
}

export function getOtherOrientationPage(template, page) {
  let otherOrientationPage;

  const originalPage = getOriginalPage(template, page);

  if (originalPage.orientation) {
    const otherOrientation = getOtherOrientation(originalPage);
    const otherOrientationPageId = originalPage[otherOrientation];

    otherOrientationPage = template.pages.find((p) => p.id === otherOrientationPageId);
  }

  return otherOrientationPage;
}

export function isChangePageOrientationEnabled(template, page) {
  return !!getOtherOrientationPage(template, page);
}
